import { useMemo } from 'react'

import { useSelector } from 'react-redux'

import { OrderStatus } from '__generated__/atlas-types'

import usePortal from 'hooks/usePortal'
import { isAccountTypeRetailer } from 'store/currentUser/selectors'

import ChangeStatusModal from 'modals/OrderList/ChangeStatusModal'
import { SelectedOrderType } from 'modals/OrderList/ChangeStatusModal/ChangeStatusModal.component'

import { useStatusUpdateToasters } from '../../joorPayOrders.hooks'
import { TableRowData } from '../../joorPayOrders.types'

export function ChangeStatusModalContainer({
  selectedOrders,
  onClose,
  onSuccess,
}: Props) {
  const Portal = usePortal()
  const isRetailer = useSelector(isAccountTypeRetailer)
  const { renderStatusUpdateToast } = useStatusUpdateToasters()

  const ordersToUpdate: SelectedOrderType[] = useMemo(
    () =>
      selectedOrders.map((order) => ({
        id: order.id,
        webOrderLookupId: order.webOrderLookupId,
      })),
    [selectedOrders],
  )

  return (
    <Portal>
      <ChangeStatusModal
        onClose={onClose}
        isRetailer={isRetailer}
        selectedOrders={ordersToUpdate}
        refetchStaticCounts={() => {}}
        renderActionsToasterMessage={renderStatusUpdateToast}
        setPageLoaderActive={() => {}}
        handleResetOrder={() => {}}
        onSuccess={onSuccess}
      />
    </Portal>
  )
}

type Props = {
  selectedOrders: TableRowData[]
  onClose: () => void
  onSuccess?: (updated: Record<string, OrderStatus>) => void
}
